import { render, staticRenderFns } from "./john-deere-tractor.vue?vue&type=template&id=22150f6c&"
import script from "./john-deere-tractor.vue?vue&type=script&lang=js&"
export * from "./john-deere-tractor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports